import {registerSavedArea} from '@gaia/utils/gaia/saveArea';
import keyBy from 'lodash/keyBy';
import pickBy from 'lodash/pickBy';

import {createArea} from './create';

export default function bulkArchive(
    action: BulkArchiveAction,
    setAreas: React.Dispatch<React.SetStateAction<{[areaLocalId: string]: Area}>>
) {
    if (!action.ids.length) return [];

    setAreas((latestAreas) => {
        let archivedAreas = action.ids.map((id) => {
            if (latestAreas[id]) {
                return {
                    ...latestAreas[id],
                    properties: {
                        ...latestAreas[id].properties,
                        archived: action.archived,
                    },
                };
            } else {
                // Create an empty area to make sure we don't show area
                // that have been deleted without being taken local
                const newArea = createArea();
                return {
                    ...newArea,
                    properties: {
                        ...newArea.properties,
                        localId: id,
                        id,
                        archived: true,
                        bulkArchived: true,
                    },
                };
            }
        });

        if (action.archived === false) {
            archivedAreas = archivedAreas.filter((area) => !area.properties.bulkArchived);
        }

        // calling registerSavedArea directly is an escape hatch to prevent the
        // save effect from picking up this change
        archivedAreas.forEach((area) => registerSavedArea(area));

        // If we are unarchiving, remove the partial local instance
        const existingAreas =
            action.archived === false
                ? pickBy(latestAreas, (area) => !area.properties.bulkArchived)
                : latestAreas;

        return {
            ...existingAreas,
            ...keyBy(archivedAreas, (area) => area.properties.localId),
        };
    });

    return action.ids;
}
